// removed by extract-text-webpack-plugin
module.exports = {"container":"_1fCSh","plansContainer":"_2BZMz","plansHeader":"_2lLQc","plansHeaderText":"_3lZIq","plansList":"_24lxm","withSuggestions":"_2r8zJ","noPlansFound":"_1-BzL","loadingText":"_1bH84"};


//////////////////
// WEBPACK FOOTER
// ./src/views/v2/search/components/plansTable/styles.module.css
// module id = 216
// module chunks = 0